import { useEffect, useRef, useState } from "react";
import { QRCodeSVG } from "qrcode.react";
import api from "../api";

const POLL_MS = 3000;

export default function PhotoSessionPanel({ patientId, onDone }) {
    const [session, setSession] = useState();
    const [error, setError] = useState();
    const idRef = useRef();

    useEffect(() => {
        let timer;
        let cancelled = false;
        api.photoSessions
            .create({ patient: patientId })
            .then((created) => {
                if (cancelled) return api.photoSessions.close(created.id);
                idRef.current = created.id;
                setSession(created);
                timer = setInterval(() => {
                    api.photoSessions
                        .getOne(created.id)
                        .then((s) => setSession((prev) => ({ ...prev, ...s })))
                        .catch(() => {});
                }, POLL_MS);
            })
            .catch(() => setError("No se pudo crear la sesión de carga."));
        return () => {
            cancelled = true;
            clearInterval(timer);
        };
    }, [patientId]);

    const finish = async () => {
        if (idRef.current) await api.photoSessions.close(idRef.current).catch(() => {});
        onDone();
    };

    const documents = session?.documents ?? [];
    const closed = session?.status && session.status !== "active";

    return (
        <div className="text-center">
            <h3 className="text-lg font-medium text-gray-900">Subir fotos desde el celular</h3>
            {error && <p className="mt-4 text-sm text-red-600">{error}</p>}
            {!session && !error && <p className="mt-4 text-sm text-gray-500">Generando código...</p>}
            {session?.uploadUrl && (
                <>
                    <p className="mt-2 text-sm text-gray-500">
                        Escaneá el código con la cámara del celular.
                    </p>
                    <div className="mt-4 flex justify-center">
                        <QRCodeSVG value={session.uploadUrl} size={200} />
                    </div>
                    {closed && (
                        <p className="mt-3 text-sm text-red-600">La sesión terminó. Generá un nuevo código.</p>
                    )}
                    <p className="mt-3 text-sm font-medium text-gray-700">
                        {documents.length} / {session.maxPhotos} fotos recibidas
                    </p>
                    <ul className="mt-2 max-h-40 overflow-y-auto text-left text-sm text-gray-600">
                        {documents.map((d) => (
                            <li key={d.id} className="truncate">{d.name}</li>
                        ))}
                    </ul>
                </>
            )}
            <button
                type="button"
                onClick={finish}
                className="mt-6 py-2 px-4 rounded-md shadow-sm text-sm font-medium text-white bg-primary"
            >
                Finalizar
            </button>
        </div>
    );
}
